
import {
  onBeforeMount,
  onUnmounted,
  onMounted,
  ref,
  nextTick,
  reactive,
  computed,
  inject,
  watch,
} from "vue";
import ActionBar from "../../components/ActionBar/index.vue";
import WrongPage from "../../components/WrongPage.vue";
import {
  getStatusBarInfo,
  nativeGoBack,
  getClientCommonMessage,
  doJump,
} from "@/utils/nativeFn";
import { getSuportBookList } from "@/api/index";
import { useRoute } from "vue-router";
export default {
  name: "SupportBookList",
  components: {
    ActionBar,
    WrongPage
  },
  setup(props, { emit }) {
    const $xesLog = inject("$xesLog") as any; // 埋点
    const bookList = ref([]); // 图书信息
    const pageInfo = ref({}); // 分页信息
    const statusBarHeight = ref(0);
    const actionBarHeight = ref(0);
    const showActionBar = ref(true);
    const actionBarInfo = reactive({}); // actionBar需要的参数
    const backIcon = require("../../assets/images/aio/aio_go_back_x.png");
    const needShare = false;
    const isLoadWrong = ref(false);
    const isShowFooter = ref(false);
    let { type } = useRoute().query || {};
    let source_location =
      type === "1"
        ? "paipai_page_photograph_skill"
        : "photograph_check_page_without_exercise";
    onMounted(() => {
      Object.assign(actionBarInfo, {
        actionBarTitle: "支持图书",
        actionBarBg: "#ffffff",
      });
      getTokenFromNative();
      getStatusBarHeight();
    });
    /**
     * 调用端上方法获取token
     */
    const getTokenFromNative = () => {
      getClientCommonMessage({}, (res) => {
        console.log("h5调用端上getClientCommonMessage", res); // app返回给前端的值
        if (localStorage.getItem("tal_token") !== res.token) {
          localStorage.setItem("tal_token", res.token);
        }
        // 支持图书列表页面曝光
        $xesLog.track("pho_sup_pv", {
          biz_name: "paipai",
          page_name: "支持图书页",
          event_name: "支持图书页浏览（H5）",
          event_type: "pv",
          event_id: "pho_sup_pv",
          source: source_location,
        });
        // 获取数据
        getSuportBook();
      });
    };
    const getSuportBook = () => {
      getSuportBookList()
        .then((res) => {
          console.log(res, "res");
          if (res.data.code === 0) {
            bookList.value = res.data.data.list;
            pageInfo.value = res.data.data.page_info;
            setTimeout(() => {
              isShowFooter.value = true;
            },0)
          }
        })
        .catch((err) => {
          console.log(err);
          isLoadWrong.value = true;
        });
    };
    /**
     * 接口请求失败后重新刷新接口请求
     */
    const clickRefresh = () => {
      isLoadWrong.value = false;
      getSuportBook();
    };
    // 左侧返回
    const goBack = () => {
      console.log("调用端返回");
      nativeGoBack({}, (res) => {
        console.log("h5调用端上nativeGoBack", res); // app返回给前端的值
      });
    };

    // 获取状态栏高度
    const getStatusBarHeight = () => {
      getStatusBarInfo({}, (res) => {
        console.log("h5调用端上getStatusBarInfo", res); // app返回给前端的值
        statusBarHeight.value = res.height;
        actionBarHeight.value = 44 + res.height;
      });
    };
    return {
      bookList,
      showActionBar,
      actionBarInfo,
      backIcon,
      needShare,
      goBack,
      actionBarHeight,
      isLoadWrong,
      clickRefresh,
      isShowFooter
    };
  },
};
